import { Subscribable } from 'knockout';
import { ShellHelpers } from 'shells/helpers/helpers';
import { ShellRoutesGroupConfig } from './routesComposition';

export default class ShellLoggedInRoutes implements ShellRoutesGroupConfig {
    enable: Subscribable<boolean>

    constructor(public routes: Array<DurandalRouteConfiguration>) {
        this.enable = ShellHelpers.isLoggedIn;
    }
}